import ITag from '../../../components/ITag'
import SecSettings from "../SecSettings/index.jsx";
import {data2, data3} from "../../../data/data-containers/data-Profile.js";
import SecNavWrapper from "../SecNavWrapper/index.jsx";
import { useAuth } from "../../../lib/auth";
import { parseSessionToken } from "../../../lib/window-shim";

let _moo = {emailaddress: ""}
let moo = parseSessionToken();
if(moo) {
  _moo = moo?.account;
}

/**
 * SecInformation component.
 *
 * Displays the "About Me" section of the profile:
 * - Bio text
 * - Location
 * - Social links (via SecNavWrapper) - in header next to title
 * - Edit Profile button (if editAllowed) - at bottom
 *
 * @param {Object} props - Component props
 * @param {Object} props.profileInfo - User profile data with bio, location, socials
 * @param {Function} props.settings - Callback to open settings modal
 * @param {boolean} props.editAllowed - Whether current user can edit this profile
 * @returns {React.ReactElement} Profile information card
 */
function SecInformation({profileInfo, settings, editAllowed}) {
  // Determine if socials should be shown based on viewer context and profile settings:
  //
  // Rules:
  // 1. Profile owner/admin (editAllowed) → always show
  // 2. Any authenticated user (logged in) → always show, even if viewing someone else's public profile
  // 3. Unauthenticated (public) viewer → respect show_socials flag
  // 4. Private profiles are only accessible to authorized users (who will see socials)
  const { isAuthenticated } = useAuth();
  const showSocialsPref = Boolean(profileInfo?.show_socials);

  // Show socials if:
  // - Viewer is owner/admin (editAllowed), OR
  // - Viewer is authenticated, OR
  // - Profile opt-in to show socials (show_socials = true)
  const shouldShowSocials = editAllowed || isAuthenticated || showSocialsPref;

  return(
      <div className="pixel-card ">
        <div className="card-header pb-0 p-3 pt-2">
          <div className="d-flex justify-content-between align-items-center">
            <span className="mb-0 text-bold text-light">About Me</span>
            {shouldShowSocials && (
              <div className="pb-1">
                <SecNavWrapper
                    socials={profileInfo?.socials ? (typeof profileInfo.socials === 'string' ? JSON.parse(profileInfo.socials) : profileInfo.socials) : null}
                    showSocials={shouldShowSocials}
                />
              </div>
            )}
          </div>
        </div>

        <div className="card-body px-3 pb-1">
          {profileInfo?.bio ? (
            <p className="text-info mb-3">
              {profileInfo.bio}
            </p>
          ) : null}
          <p className="mb-3">
            <strong className="text-light">Location:</strong>
            <span className="text-info ms-2">{profileInfo?.location || 'Not specified'}</span>
          </p>

          {/* Edit button at bottom */}
          {editAllowed && (
            <div className="text-end">
              <button onClick={()=>settings()}
                     className="btn btn-sm btn-icon-only bg-gradient-light rounded-circle"
                     style={{width: '40px', height: '40px'}}>
                  <ITag ClassName="fa fa-pen" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit Profile"/>
              </button>
            </div>
          )}
        </div>
      </div>
  )
}

export default SecInformation
